import { useState, useEffect } from "react";
import { Outlet, useOutletContext, useLocation } from "react-router-dom";
import SubNav from "Components/Navbar/SubNav/SubNav";

interface Crumb {
  label: string;
  link?: string;
}

export interface BankOutletContext {
  setCrumbs: (crumbs: Crumb[]) => void;
}

export function useBankLayout() {
  return useOutletContext<BankOutletContext>();
}

const CRUMB_MAP: Record<string, Crumb[]> = {
  "/bank-dashboard": [{ label: "My Projects" }],
  "/bank-add-project": [
    { label: "My Projects", link: "/bank-dashboard" },
    { label: "New Project" },
  ],
};

export default function BankLayout() {
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("darkMode") === "true",
  );
  const toggleDark = () =>
    setDarkMode((d) => {
      localStorage.setItem("darkMode", String(!d));
      return !d;
    });
  const { pathname } = useLocation();
  const defaultCrumbs = CRUMB_MAP[pathname] ?? [
    { label: "My Projects", link: "/bank-dashboard" },
  ];
  const [crumbs, setCrumbs] = useState<Crumb[]>(defaultCrumbs);

  useEffect(() => {
    setCrumbs(
      CRUMB_MAP[pathname] ?? [
        { label: "My Projects", link: "/bank-dashboard" },
      ],
    );
  }, [pathname]);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const firstName: string = user?.firstName ?? "";
  const lastName: string = user?.lastName ?? "";
  const userName = `${firstName} ${lastName}`.trim() || "Lender User";
  const userInitials =
    `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase() || "LU";
  const role: string = user?.companyName ?? "";

  return (
    <div className={darkMode ? "dm" : ""}>
      <SubNav
        toggleDark={toggleDark}
        darkMode={darkMode}
        crumbs={crumbs}
        userInitials={userInitials}
        role={role}
        userName={userName}
        logoClass="drawLogo"
        notifications={true}
      />
      <Outlet context={{ setCrumbs } satisfies BankOutletContext} />
    </div>
  );
}
